import script from "./OnboardingSupportButton.vue?vue&type=script&setup=true&lang=js"
export * from "./OnboardingSupportButton.vue?vue&type=script&setup=true&lang=js"

import "./OnboardingSupportButton.vue?vue&type=style&index=0&id=b7ad0352&scoped=true&lang=css"

import exportComponent from "/opt/bitnami/projects/OrganiCuentas/front_end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7ad0352"]])

export default __exports__